export default "skymp5-front/98895887b22eca6d97f7b40709340c5a.png";